import { render, staticRenderFns } from "./SoftItem.vue?vue&type=template&id=dacff886&scoped=true"
import script from "./SoftItem.vue?vue&type=script&lang=js"
export * from "./SoftItem.vue?vue&type=script&lang=js"
import style0 from "./SoftItem.vue?vue&type=style&index=0&id=dacff886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacff886",
  null
  
)

export default component.exports